import { render, staticRenderFns } from "./dashboardLeadsUnit.vue?vue&type=template&id=0d964050&scoped=true&"
import script from "./dashboardLeadsUnit.vue?vue&type=script&lang=js&"
export * from "./dashboardLeadsUnit.vue?vue&type=script&lang=js&"
import style0 from "./dashboardLeadsUnit.vue?vue&type=style&index=0&id=0d964050&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d964050",
  null
  
)

export default component.exports